import * as React from 'react'
function SvgHome(props) {
	return (
		<svg
			width="1em"
			height="1em"
			viewBox="0 0 40 40"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M31.47 36c1.13 0 1.883-.753 1.883-1.882V17.176c0-.564-.188-1.129-.753-1.505L21.306 6.259c-.753-.565-1.694-.565-2.447 0L7.565 15.67c-.377.376-.565.94-.565 1.505v16.942C7 35.248 7.753 36 8.882 36h5.53a2 2 0 002-2v-7.412h7.53V34a2 2 0 002 2h5.529z"
				fill="currentColor"
				fillRule="evenodd"
			/>
		</svg>
	)
}
export default SvgHome
